
<template>
    <div class="modem-settings">
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a class="nav-link" :class="[currentTab === 'main' ? 'active': '']" data-toggle="tab" @click="currentTab = 'main'">Основное</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" :class="[currentTab === 'extension' ? 'active': '']" data-toggle="tab" @click="currentTab = 'extension'">Дополнительное</a>
            </li>
        </ul>
        <div v-if="currentTab === 'main'">
            <div class="d-flex flex-column flex-sm-row">
                <div class="flex-fill">
                    <small class="d-block text-muted mb-2">Десятичная точка</small>

                    <div class="d-flex justify-content-between">
                        <ValidationProvider v-errors.api tag="div" vid="dp_pos_cash" class="form-group flex-fill" rules="integer|between:0,3">
                            <input v-model="dp_pos_cash" type="number" min="0" max="3" class="form-control" placeholder="Нал">
                        </ValidationProvider>

                        <ValidationProvider v-errors.api tag="div" vid="dp_pos_cashless" class="form-group flex-fill ml-2" rules="integer|between:0,3">
                            <input v-model="dp_pos_cashless" type="number" min="0" max="3" class="form-control" placeholder="Безнал">
                        </ValidationProvider>
                    </div>
                </div>

                <div class="flex-fill ml-sm-3" style="display: none">
                    <small class="d-block text-muted mb-2">Scale factor</small>

                    <div class="d-flex justify-content-between">
                        <ValidationProvider v-errors.api tag="div" vid="scale_cash" class="form-group flex-fill" rules="integer|between:1,100">
                            <input v-model="scale_cash" type="number" min="1" max="100" class="form-control" placeholder="Cash">
                        </ValidationProvider>

                        <ValidationProvider v-errors.api tag="div" vid="scale_cashless" class="form-group flex-fill ml-2" rules="integer|between:1,100">
                            <input v-model="scale_cashless" type="number" min="1" max="100" class="form-control" placeholder="Cashless">
                        </ValidationProvider>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column flex-sm-row">
                <div class="flex-fill">
                    <ValidationProvider v-if="hasCrt" v-errors.api vid="is_crt_active" tag="div" class="custom-control custom-checkbox mb-3 mb-xl-0">
                        <input id="is_crt_active" v-model="form.is_crt_active" type="checkbox" class="custom-control-input">
                        <label class="custom-control-label" for="is_crt_active">Отправлять чеки</label>
                    </ValidationProvider>
                </div>
            </div>
        </div>
        <div v-if="currentTab === 'extension'">
            <div class="d-flex flex-column flex-sm-row">
                <div class="flex-fill">
                    <div class="custom-control custom-checkbox mb-3 mb-xl-0">
                        <input id="sound" v-model="sound" :true-value="1" :false-value="0" type="checkbox" class="custom-control-input">
                        <label class="custom-control-label" for="sound">Звук</label>
                    </div>
                </div>
            </div>
            <div v-if="form.cashless_available" class="d-flex flex-column flex-sm-row">
                <div class="flex-fill">
                    <div class="custom-control custom-checkbox mb-3 mb-xl-0">
                        <input id="cashless_mode" v-model="cashless_mode" :true-value="1" :false-value="0" type="checkbox" class="custom-control-input">
                        <label class="custom-control-label" for="cashless_mode">Донгл (программная эмуляция cashless)</label>
                    </div>
                </div>
                <div class="flex-fill">
                    <div class="custom-control custom-checkbox mb-3 mb-xl-0">
                        <label>Адрес на шине</label>
                        <div class="btn-group">
                            <button type="button"
                                    class="btn btn-primary btn-sm"
                                    :class="[cashless_address == 1 ? 'active': '']"
                                    @click="cashless_address = 1">
                                1
                            </button>
                            <button
                                type="button"
                                class="btn btn-primary btn-sm"
                                :class="[cashless_address == 2 ? 'active': '']"
                                @click="cashless_address = 2">
                                2
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'

const computedSetHelper = key => ({
    get() {
        return this.sets[key]
    },
    set(value) {
        this.$emit('set', { key, value })
    }
})

const computedFormHelper = key => ({
    get() {
        return this.form[key]
    },
    set(value) {
        this.$emit('form', { key, value })
    }
})

export default {
    components: {
        ValidationProvider
    },

    props: {
        sets: {
            type: Object,
            default: _ => ({})
        },
        form: {
            type: Object,
            default: _ => ({})
        },
        hasCrt: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            currentTab: 'main'
        }
    },

    computed: {
        dp_pos_cash: computedSetHelper('dp_pos_cash'),
        dp_pos_cashless: computedSetHelper('dp_pos_cashless'),
        scale_cash: computedSetHelper('scale_cash'),
        scale_cashless: computedSetHelper('scale_cashless'),
        sound: computedSetHelper('sound'),
        cashless_mode: computedSetHelper('cashless_mode'),
        cashless_address: computedSetHelper('cashless_address'),

        is_crt_active: computedFormHelper('is_crt_active')
    }
}
</script>
